export default "__VITE_ASSET__DlkjwA42__"